// SNKRR BAR cart drawer upsell handler
// Uses Shopify Sections API to refresh the cart drawer + bubble after AJAX add.
// Also adds a dismiss (x) button to the in-cart cross-sell card. Dismissal is
// remembered for the browser session and survives cart-drawer re-renders.
(function(){
  'use strict';

  // ---- Dismissible upsell card ----
  var dismissStyle = document.createElement('style');
  dismissStyle.textContent =
    '.snkrr-cart-upsell{position:relative;}' +
    '.snkrr-cart-upsell__close{position:absolute;top:10px;right:10px;width:26px;height:26px;border:none;background:rgba(0,0,0,.07);color:#0b0b0b;border-radius:50%;font-size:18px;line-height:1;cursor:pointer;display:grid;place-items:center;padding:0;z-index:2;transition:background .15s;}' +
    '.snkrr-cart-upsell__close:hover{background:rgba(0,0,0,.16);}' +
    'html.snkrr-upsell-off .snkrr-cart-upsell{display:none !important;}';
  document.head.appendChild(dismissStyle);

  // Restore dismissed state for this session
  try {
    if (sessionStorage.getItem('snkrrUpsellOff') === '1') {
      document.documentElement.classList.add('snkrr-upsell-off');
    }
  } catch (e) {}

  // Inject the close button into any upsell card that does not have one yet
  function ensureCloseButton(){
    var cards = document.querySelectorAll('.snkrr-cart-upsell');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('[data-upsell-close]')) continue;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'snkrr-cart-upsell__close';
      b.setAttribute('aria-label', 'Dismiss');
      b.setAttribute('data-upsell-close', '');
      b.innerHTML = '&times;';
      cards[i].insertBefore(b, cards[i].firstChild);
    }
  }
  ensureCloseButton();

  // The cart drawer re-renders its contents on every cart change; re-add the button
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && window.MutationObserver) {
    new MutationObserver(ensureCloseButton).observe(drawerEl, { childList: true, subtree: true });
  }

  // Dismiss on click (delegated so it works after re-renders)
  document.addEventListener('click', function(e){
    var close = e.target.closest('[data-upsell-close]');
    if (!close) return;
    e.preventDefault();
    document.documentElement.classList.add('snkrr-upsell-off');
    try { sessionStorage.setItem('snkrrUpsellOff', '1'); } catch (err) {}
  });

  // ---- AJAX add for the upsell "Add" button ----
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.snkrr-cart-upsell__btn');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var label = btn.querySelector('.snkrr-cart-upsell__btn-label');
    var original = label ? label.textContent : 'Add';
    btn.disabled = true;
    if (label) label.textContent = 'Adding...';

    var sectionsList = 'cart-drawer,cart-icon-bubble';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/javascript'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsList.split(','),
        sections_url: window.location.pathname
      })
    })
    .then(function(r){ return r.json(); })
    .then(function(data){
      if (data && data.status >= 400) throw new Error(data.description || 'Add failed');

      var sections = data && data.sections ? data.sections : null;
      if (!sections) {
        return fetch(window.location.pathname + '?sections=' + sectionsList).then(function(r){ return r.json(); });
      }
      return sections;
    })
    .then(function(sections){
      if (!sections) return;

      var cartDrawer = document.querySelector('cart-drawer');
      if (sections['cart-drawer'] && cartDrawer) {
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.innerHTML = fresh.innerHTML;
          // Re-bind overlay close
          var overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }
      }

      var bubble = document.getElementById('cart-icon-bubble');
      if (sections['cart-icon-bubble'] && bubble) {
        var bdoc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = bdoc.getElementById('cart-icon-bubble');
        if (freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }

      if (label) label.textContent = 'Added';
      setTimeout(function(){
        // Drawer may have been replaced — find the new button if present, otherwise reset original
        if (btn.isConnected) {
          btn.disabled = false;
          if (label) label.textContent = original;
        }
      }, 1500);
    })
    .catch(function(err){
      console.error('SNKRR cart upsell error:', err);
      btn.disabled = false;
      if (label) label.textContent = original;
    });
  });
})();
